import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import PriceFactorsMaintenance from './query/list';
import PriceFactorsAdd from './add';
import PriceFactorsEditOrClone from './editOrClone';

export const priceFactorsRoutes = [
  {
    'component': <PriceFactorsMaintenance />,
    'path': paths.PriceFactorsMaintenance,
  },
  {'component': <PriceFactorsAdd />, 'path': paths.PriceFactorsAdd},
  {'component': <PriceFactorsEditOrClone />, 'path': paths.PriceFactorsEdit},
  {
    'component': <PriceFactorsEditOrClone />,
    'path': paths.PriceFactorsClone,
  },
];
